import { generateQueryKey } from 'query';
import type { VideosListSorter } from '../models';
import type { VideoScope } from '../types';

type VideosQueryType = {
  filter?: { featured?: boolean; scope?: VideoScope; search?: string };
  pagination?: { pageSize?: number };
  sort?: VideosListSorter;
};

// TODO: split video
export const getVideosQueryKey = ({ filter = {}, pagination = {} }: VideosQueryType) =>
  generateQueryKey(['videos', { filter, pagination }]);

export const getVideosInfiniteQueryKey = ({ filter = {}, pagination = {}, sort }: VideosQueryType) =>
  generateQueryKey(['videos', { filter, pagination, sort }, 'infinite']);

export const getVideoDetailQueryKey = (params: { videoId: string }) => generateQueryKey(['videos', 'detail', params]);

export const getMediaQueryKey = (params: { mediaId?: string }) => generateQueryKey(['media', 'detail', params]);
